module.exports = __webpack_public_path__ + "static/media/valor4_1.1509f665.png";